import { render, staticRenderFns } from "./ShowModalityRegister.vue?vue&type=template&id=57230e3a&scoped=true"
import script from "./ShowModalityRegister.vue?vue&type=script&lang=js"
export * from "./ShowModalityRegister.vue?vue&type=script&lang=js"
import style0 from "./ShowModalityRegister.vue?vue&type=style&index=0&id=57230e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57230e3a",
  null
  
)

export default component.exports